import styled, { keyframes } from 'styled-components';
import Burst from '../svgs/Burst/BurstM.svg';

const burstRotation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const AnimatedBurst = styled.img.attrs({
  src: Burst,
  alt: '',
})`
  animation: ${burstRotation} 20s linear infinite;
  position: absolute;
  transform-origin: center center;
  top: -217;
  left: 0;
  width: 1024;
  height: 1024;
  opacity: 0.2;
`;

export default AnimatedBurst;
